import { Zap, Clock, DoorOpen, FolderDown, FileX, DollarSign, Target, Smartphone, Pencil, Tag, type LucideIcon } from "lucide-react";

export const REALITY_ITEMS = [
  "Large upfront fee",
  "Weeks or months of waiting",
  "Extra charges for every edit",
  "Expensive ongoing maintenance",
];

export const REALITY_ITEMS_2 = [
  "Hard to update yourself",
  "No clear lead-generation strategy",
  "Locked into one developer",
  "Surprise fees after launch",
];

export type FeatureItem = { icon: LucideIcon; label: string };

export const FEATURES: FeatureItem[] = [
  { icon: Zap, label: "Free mockup back in hours" },
  { icon: Clock, label: "Final site live within 72 hours of approval" },
  { icon: DoorOpen, label: "Cancel anytime" },
  { icon: FolderDown, label: "Take your website with you" },
  { icon: FileX, label: "No contracts locking you in" },
];

export const FEATURES_2: FeatureItem[] = [
  { icon: DollarSign, label: "No surprise edit fees" },
  { icon: Target, label: "Built to generate leads" },
  { icon: Smartphone, label: "Mobile-friendly and SEO-ready" },
  { icon: Pencil, label: "Easy to update later" },
  { icon: Tag, label: "Clear pricing from the start" },
];

export const LAUNCH_BENEFITS = [
  "Own your website outright",
  "Lower monthly support cost",
  "Best for simple business sites",
];

export const GROWTH_BENEFITS = [
  "Low upfront cost to launch",
  "Unlimited edits included",
  "Everything handled for you",
];

export const CUSTOM_BENEFITS = [
  "Brand and website strategy",
  "Ecommerce or custom functionality",
  "Built around your business needs",
];

export const UNLIMITED_INCLUDED = [
  "Unlimited design requests",
  "Website edits + landing pages",
  "Social media graphics",
  "Ad creative + promo graphics",
  "Average 48 hour delivery",
  "One active request at a time",
  "Unlimited revisions",
  "Source files included",
];
